export default __webpack_public_path__ + "static/media/icon_function_guide.33d0f721.svg";